import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { cancelOrder } from "../../../domestic/orders/thunks/cancelOrderThunk";
import { setCancelOrderFetchState } from "../../../domestic/orders/orderBookDataSlice";

export const useCancelOrder = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		store => store.data.domestic.orderBook.cancelOrderFetchState
	);

	const dispatch = useDispatch();
	const dispatchCancelOrder = React.useCallback(
		(id: string) => dispatch(cancelOrder(id)),
		[dispatch]
	);

	React.useEffect(() => {
		return () => {
			dispatch(setCancelOrderFetchState({ type: "not-started" }))
		}
	}, [dispatch])

	return [fetchState, dispatchCancelOrder] as [typeof fetchState, typeof dispatchCancelOrder]
};
